// These can be found in app-schemata, e.g.:
// https://github.com/NerdWallet/app-schemata/blob/master/analytic_pipeline/page_impression.yaml
// Base events which must be extended are not documented here.
// Events which aren't relevant to the Member experience are not surfaced here.
//
// Todo: import all this from app-schemata
export var VERTICAL = {
  UNKNOWN: 'UNKNOWN',
  AUTO_INSURANCE: 'Auto Insurance',
  AUTO_LOANS: 'Auto Loans',
  BANKING: 'Banking',
  BILLS: 'Bills',
  COMMUNITY: 'Community',
  CORPORATE: 'Corporate',
  CREDIT: 'Credit',
  CREDIT_CARDS: 'Credit Cards',
  DEBT: 'Debt',
  DECIDING_TO_BUY: 'Deciding to Buy',
  HEALTH: 'Health',
  HOMEOWNERS_INSURANCE: 'Homeowners Insurance',
  INVESTING: 'Investing',
  LIFE_INSURANCE: 'Life Insurance',
  MAKING_MONEY: 'Making Money',
  MANAGING_MONEY: 'Managing Money',
  OTHER_INSURANCE: 'Other Insurance',
  OTHER_LOANS: 'Other Loans',
  OWNING_A_HOME: 'Owning a Home',
  PERSONAL_LOANS: 'Personal Loans',
  SELLING_A_HOME: 'Selling a Home',
  SHOPPING: 'Shopping',
  SHOPPING_FOR_A_HOME: 'Shopping for a Home',
  SHOPPING_FOR_A_MORTGAGE: 'Shopping for a Mortgage',
  SMALL_BUSINESS: 'Small Business',
  STUDENT_LOANS: 'Student Loans',
  TAXES: 'Taxes',
  TRAVEL: 'Travel',
  UTILITIES: 'Utilities',
  YOUR_ACCOUNT: 'Your Account',
  YOUR_CAR: 'Your Car',
  YOUR_CREDIT_SCORE: 'Your Credit Score',
  YOUR_HOUSE: 'Your House',
  YOUR_MEMBER_HOME: 'Your Member Home',
  YOUR_MONEY: 'Your Money',
  YOUR_OFFERS: 'Your Offers',
  YOUR_REWARDS: 'Your Rewards',
  YOUR_TRANSFERS: 'Your Transfers',
  // deprecated
  YOUR_DASHBOARD: 'UNKNOWN',
  YOUR_HOME: 'UNKNOWN'
};
export var TOPIC = {
  UNKNOWN: 'UNKNOWN',
  ABOUT: 'About',
  ADJUSTABLE_RATE_MORTGAGES: 'Adjustable Rate Mortgages',
  ADVISORS: 'Advisors',
  AIRLINE_CREDIT_CARDS: 'Airline Credit Cards',
  AIRLINE_FEES: 'Airline Fees',
  AIRPORT_DETAILS: 'Airport Details',
  ALL_DEALS: 'All Deals',
  APPLYING_FOR_A_MORTGAGE: 'Applying for a Mortgage',
  ASK_AN_ADVISOR: 'Ask An Advisor',
  AUTO_INSURANCE_BASICS: 'Auto Insurance Basics',
  AUTO_INSURER_REVIEWS: 'Auto Insurer Reviews',
  AUTO_LENDER_REVIEWS: 'Auto Lender Reviews',
  AUTO_LOANS_BASICS: 'Auto Loans Basics',
  BALANCE_TRANSFER_CREDIT_CARDS: 'Balance Transfer Credit Cards',
  BANK_AND_CREDIT_UNION_REVIEWS: 'Bank & Credit Union Reviews',
  BANK_BONUSES_AND_PROMOTIONS: 'Bank Bonuses & Promotions',
  BANKING_BASICS: 'Banking Basics',
  BANKING_NEWS: 'Banking News',
  BANKRUPTCY: 'Bankruptcy',
  BEST_CREDIT_CARDS: 'Best Credit Cards',
  BEST_PLACES_STUDIES: 'Best Places Studies',
  BEST_OF_AWARDS: 'Best-Of Awards',
  BLACK_FRIDAY: 'Black Friday',
  BROKERAGES: 'Brokerages',
  BUDGETING: 'Budgeting',
  BUSINESS_CREDIT_CARDS: 'Business Credit Cards',
  BUYING_AUTO_INSURANCE: 'Buying Auto Insurance',
  BUYING_HOMEOWNERS_INSURANCE: 'Buying Homeowners Insurance',
  BUYING_LIFE_INSURANCE: 'Buying Life Insurance',
  BUYING_A_CAR: 'Buying a Car',
  BUYING_A_SECOND_HOME: 'Buying a Second Home',
  CDS: 'CDs',
  CAR_TITLE_LOANS: 'Car Title Loans',
  CAREERS: 'Careers',
  CASH_BACK_CREDIT_CARDS: 'Cash Back Credit Cards',
  CASH_MANAGEMENT_ACCOUNTS: 'Cash Management Accounts',
  CELL_PHONES: 'Cell Phones',
  CHECKING_ACCOUNTS: 'Checking Accounts',
  CLOSING_COSTS_AND_PROCESS: 'Closing Costs and Process',
  COLLEGE_AND_EARLY_ADULTHOOD: 'College / Early Adulthood',
  COLLEGE_SAVINGS: 'College Savings',
  COMMUNITY_ACCOUNT_HELP: 'Community Account Help',
  COMMUNITY_BASICS: 'Community Basics',
  COMPANY_BLOG: 'Company Blog',
  COMPARE_PRODUCTS: 'Compare Products',
  COST_OF_HOME_IMPROVEMENTS: 'Cost of Home Improvements',
  COST_OF_LIVING: 'Cost of Living',
  CREDIT_BUILDING: 'Credit Building',
  CREDIT_CARD_BASICS: 'Credit Card Basics',
  CREDIT_CARD_DATA: 'Credit Card Data',
  CREDIT_CARD_PROMOS: 'Credit Card Promos',
  CREDIT_CARDS_FOR_AVERAGE_OR_FAIR_CREDIT: 'Credit Cards for Average or Fair Credit',
  CREDIT_CARDS_FOR_BAD_CREDIT: 'Credit Cards for Bad Credit',
  CREDIT_COUNSELING: 'Credit Counseling',
  CREDIT_PROFILE_SECURITY: 'Credit Profile Security',
  CREDIT_REPORT: 'Credit Report',
  CREDIT_SCORE: 'Credit Score',
  CREDIT_SCORE_RANGE: 'Credit Score Range',
  CREDIT_SCORES_FOR_MORTGAGES: 'Credit Scores for Mortgages',
  DAILY_DEALS: 'Daily Deals',
  DEBT_COLLECTION: 'Debt Collection',
  DEBT_CONSOLIDATION: 'Debt Consolidation',
  DEBT_CONSOLIDATION_LOAN: 'Debt Consolidation Loan',
  DEBT_PAYOFF: 'Debt Payoff',
  DEBT_SETTLEMENT: 'Debt Settlement',
  DECIDING_TO_RENT_VS_BUY: 'Deciding to Rent vs. Buy',
  DISABILITY_INSURANCE: 'Disability Insurance',
  DOWN_PAYMENT: 'Down Payment',
  ENERGY_GAS_AND_WATER: 'Energy, Gas & Water',
  ENGINEERING_BLOG: 'Engineering Blog',
  ESTATE_PLANNING: 'Estate Planning',
  FHA_LOANS: 'FHA Loans',
  FINANCIAL_ACCOUNT_AGGREGATION: 'Financial Account Aggregation',
  FINANCIAL_EDUCATION: 'Financial Education',
  FINANCIAL_HEALTH: 'Financial Health',
  FIND_INSTITUTIONS: 'Find Institutions',
  FINDING_HEALTH_INSURANCE: 'Finding Health Insurance',
  FIRST_TIME_HOME_BUYERS: 'First-time Home Buyers',
  FREE_MONEY: 'Free Money',
  FRUGAL_LIVING: 'Frugal Living',
  GENERAL_DISCUSSION: 'General Discussion',
  GENERAL_HOMEBUYING_AND_MORTGAGES_TIPS: 'General Homebuying & Mortgages Tips',
  GENERAL_MORTGAGE_LENDER_AND_BROKER_TIPS: 'General Mortgage Lender & Broker Tips',
  GET_OFFER: 'Get Offer',
  GET_STOCK_QUOTES: 'Get Stock Quotes',
  GETTING_A_PERSONAL_LOAN: 'Getting a Personal Loan',
  GIG_ECONOMY: 'Gig Economy',
  HANDLING_BILLS: 'Handling Bills',
  HAVING_A_CAR: 'Having a Car',
  HELP_AND_FAQS: 'Help / FAQs',
  HOLIDAY_TIPS_AND_NEWS: 'Holiday Tips & News',
  HOLIDAYS: 'Holidays',
  HOME_AFFORDABILITY: 'Home Affordability',
  HOME_EQUITY: 'Home Equity',
  HOME_PR_STUDIES: 'Home PR Studies',
  HOME_VALUE: 'Home Value',
  HOMEOWNERS_INSURANCE_BASICS: 'Homeowners Insurance Basics',
  HOMEOWNERS_INSURER_REVIEWS: 'Homeowners Insurer Reviews',
  HOSPITAL_DETAILS: 'Hospital Details',
  HOUSING_AND_MORTGAGE_TRENDS: 'Housing & Mortgage Trends',
  HOW_I_BOUGHT_A_HOME: 'How I Bought a Home',
  HOW_TO_SAVE: 'How to Save',
  INSPECTIONS_AND_APPRAISALS: 'Inspections and Appraisals',
  INTEGRATED_ACCOUNT_OPENING: 'Integrated Account Opening',
  INTERNET_AND_TV: 'Internet & TV',
  INVESTING_STRATEGY: 'Investing Strategy',
  INVESTMENT_PROPERTIES: 'Investment Properties',
  LEADERSHIP: 'Leadership',
  LEGAL: 'Legal',
  LIFE_AND_MONEY: 'Life & Money',
  LIFE_INSURANCE_BASICS: 'Life Insurance Basics',
  LIFE_INSURER_REVIEWS: 'Life Insurer Reviews',
  LOGIN: 'Login',
  LONG_TERM_CARE_INSURANCE: 'Long Term Care Insurance',
  LOW_INTEREST_AND_NO_FEE_CREDIT_CARDS: 'Low Interest & No Fee Credit Cards',
  LOYALTY_PROGRAMS: 'Loyalty Programs',
  MAKING_AN_OFFER_ON_A_HOME: 'Making an Offer on a Home',
  MANAGING_HEALTH_INSURANCE: 'Managing Health Insurance',
  MANAGING_MEDICAL_BILLS: 'Managing Medical Bills',
  MANAGING_YOUR_MORTGAGE: 'Managing Your Mortgage',
  MEDICAL_COSTS: 'Medical Costs',
  MEMBER_HOME: 'Member Home',
  MEMBER_MARKETPLACE: 'Member Marketplace',
  MEMBER_SIGNUP_AND_SIGNIN: 'Member Sign-Up / Sign In',
  MONEY_MARKET_ACCOUNTS: 'Money Market Accounts',
  MONEY_TRANSFER: 'Money Transfer',
  MORTGAGE_INSURANCE: 'Mortgage Insurance',
  MORTGAGE_RATES: 'Mortgage Rates',
  MORTGAGE_REFINANCE: 'Mortgage Refinance',
  MORTGAGE_TERM: 'Mortgage Term',
  MOVING: 'Moving',
  NEARBY_DEALS: 'Nearby Deals',
  NET_WORTH: 'Net Worth',
  NON_GOVERNMENT_LOAN_TYPES: 'Non-Government Loan Types',
  NONTRADITIONAL_MORTGAGES: 'Nontraditional Mortgages',
  ONBOARDING: 'Onboarding',
  ONLINE_DEALS: 'Online Deals',
  OTHER_VEHICLE_INSURANCE: 'Other Vehicle Insurance',
  OUR_WRITERS: 'Our Writers',
  PARENTING: 'Parenting',
  PARTNERS: 'Partners',
  PAWNSHOP_LOANS: 'Pawnshop Loans',
  PAYDAY_LOANS: 'Payday Loans',
  PAYING_FOR_COLLEGE: 'Paying for College',
  PERSONAL_LOAN_LENDER_REVIEWS: 'Personal Loan Lender Reviews',
  PERSONAL_LOAN_RATES: 'Personal Loan Rates',
  PET_INSURANCE: 'Pet Insurance',
  PLANNING_FOR_COLLEGE: 'Planning for College',
  PREQUAL_FLOW: 'Pre-Qual Flow',
  PREPAID_DEBIT_CARDS: 'Prepaid Debit Cards',
  PREQUALIFYING_AND_PREAPPROVAL: 'Prequalifying and Preapproval',
  PRESS_KIT: 'Press Kit',
  PRESS_RELEASES_AND_NEWS: 'Press Releases & News',
  PRODUCT_COMPARISONS: 'Product Comparisons',
  PROPERTY_TAXES: 'Property Taxes',
  REFINANCING_STUDENT_DEBT: 'Refinancing Student Debt',
  REGISTRATION: 'Registration',
  RELATIONSHIPS: 'Relationships',
  RENTERS_INSURANCE: 'Renters Insurance',
  REPAYING_STUDENT_DEBT: 'Repaying Student Debt',
  RETIREMENT_ACCOUNTS: 'Retirement Accounts',
  REVERSE_MORTGAGES: 'Reverse Mortgages',
  REWARD_OPTIMIZATION: 'Reward Optimization',
  REWARDS_CREDIT_CARDS: 'Rewards Credit Cards',
  RUNNING_YOUR_BUSINESS: 'Running Your Business',
  SAVINGS_ACCOUNTS: 'Savings Accounts',
  SCAMS: 'Scams',
  SECURITY: 'Security',
  SELECTING_A_MORTGAGE_LENDER: 'Selecting a Mortgage Lender',
  SELLING_A_HOME: 'Selling a Home',
  SETTINGS: 'Settings',
  SHOPPING_NEWS: 'Shopping News',
  SHOPPING_TIPS: 'Shopping Tips',
  SMALL_BUSINESS_LENDER_REVIEWS: 'Small Business Lender Reviews',
  SMALL_BUSINESS_LOANS: 'Small Business Loans',
  SOCIAL_SECURITY: 'Social Security',
  STARTING_A_BUSINESS: 'Starting a Business',
  STUDENT_CREDIT_CARDS: 'Student Credit Cards',
  STUDENT_LOAN_LENDER_REVIEWS: 'Student Loan Lender Reviews',
  TAX_PLANNING: 'Tax Planning',
  TAX_PREPARATION: 'Tax Preparation',
  TIPS_FOR_HOMEOWNERS: 'Tips for Homeowners',
  TRAVEL_AND_REWARDS: 'Travel & Rewards',
  TRAVEL_CREDIT_CARDS: 'Travel Credit Cards',
  TRAVEL_DEALS: 'Travel Deals',
  TRAVEL_INSURANCE: 'Travel Insurance',
  TYPES_OF_HOMES_TO_BUY: 'Types of Homes to Buy',
  TYPES_OF_PERSONAL_LOANS: 'Types of Personal Loans',
  USDA_LOANS: 'USDA Loans',
  USER_QUESTIONS: 'User Questions',
  USER_REVIEWS: 'User Reviews',
  VA_LOANS: 'VA Loans',
  VACATIONS_AND_TRIP_PLANNING: 'Vacations & Trip Planning',
  WEDDINGS: 'Weddings',
  WHAT_AFFECTS_YOUR_CREDIT_SCORE: 'What Affects Your Credit Score',
  WORKING_WITH_REAL_ESTATE_AGENTS: 'Working with Real Estate Agents',
  YOUR_BALANCES: 'Your Balances',
  YOUR_BILLS: 'Your Bills',
  YOUR_CAR: 'Your Car',
  YOUR_CARDS: 'Your Cards',
  YOUR_CREDIT_SCORE: 'Your Credit Score',
  YOUR_CONNECTED_ACCOUNTS: 'Your Connected Accounts',
  YOUR_DEBT: 'Your Debt',
  YOUR_HOUSE: 'Your House',
  YOUR_REWARDS: 'Your Rewards',
  YOUR_SAVINGS: 'Your Savings',
  YOUR_SPENDING: 'Your Spending',
  YOUR_TRANSFERS: 'Your Transfers',
  // deprecated
  ACCOUNTS_AND_SETTINGS: 'UNKNOWN',
  YOUR_DASHBOARD: 'UNKNOWN',
  YOUR_HOME: 'UNKNOWN'
};
export var PAGE_TEMPLATE = {
  UNKNOWN: 'UNKNOWN',
  CALCULATOR: 'Calculator',
  COLUMN: 'Column',
  DASHBOARD: 'Dashboard',
  DASHBOARD_DETAIL: 'Dashboard Detail',
  ESSAY: 'Essay',
  GENERAL_ANSWER: 'General Answer',
  GUIDES: 'Guides',
  HEAD_TO_HEAD: 'Head-to-Head',
  HEAD_TO_HEAD_PRODUCT: 'Head-to-Head (Product)',
  HOME_PAGE: 'Home Page',
  IAA: 'Insights and Actions',
  INVESTIGATIVE: 'Investigative',
  LEGACY: 'Legacy',
  LIFESTYLE: 'Lifestyle',
  LISTICLE: 'Listicle',
  ONBOARDING: 'Onboarding',
  PREQUAL: 'PreQual',
  RECOMMENDATION: 'Recommendation',
  RECOMMENDATION_DETAIL: 'Recommendation Detail',
  RESOURCE: 'Resource',
  REVIEW_INSTITUTION: 'Review (Institution)',
  REVIEW_PRODUCT: 'Review (Product)',
  ROUNDUP: 'Roundup',
  STEP_BY_STEP: 'Step-by-Step',
  STUDIES: 'Studies',
  TIMELY_STORY: 'Timely Story',
  TOOL: 'Tool',
  TOPIC_HUB: 'Topic Hub',
  VERTICAL_HUB: 'Vertical Hub'
};
export var PAGE_TYPE = {
  UNKNOWN: 'UNKNOWN',
  ARTICLE: 'Article',
  CALCULATOR: 'Calculator',
  HOMEPAGE: 'Home Page',
  HUB: 'Hub',
  IAA: 'Insights and Actions',
  MEMBER_HOME: 'Member Home',
  OFFERS: 'Offers',
  OFFER_DETAIL: 'Offer Detail',
  RECOMMENDATION: 'Recommendation',
  REVIEW: 'Review',
  ROUNDUP: 'Roundup',
  SETTINGS: 'Settings',
  SIGNUP: 'Signup',
  TOOL: 'Tool',
  // deprecated
  DASHBOARD: 'UNKNOWN',
  ONBOARDING: 'UNKNOWN'
};
export var FUNNEL_STAGE = {
  UNKNOWN: 'UNKNOWN',
  DECIDE: 'Decide',
  LEARN: 'Learn',
  LEARN_DECIDE: 'Learn-Decide',
  MANAGE: 'Manage',
  NAVIGATE: 'Navigate',
  ONBOARD: 'Onboard',
  PREQUAL: 'PreQual',
  REGISTER: 'Register',
  TRANSACT: 'Transact',
  // deprecated
  ACCOUNT: 'UNKNOWN'
};